<template>
<v-container fluid>
<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="-1"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
 </v-snackbar>

  <v-layout class="main-layout">
  <v-flex xs12>
    <v-card>
      <v-card-text>
        <v-layout>
          <v-flex xs3>
            <span class="accent--text" style="font-size: 14px; font-weight:700;"> Miller Charges </span>
            <v-spacer v-if="userId"></v-spacer>
          </v-flex>
          <v-spacer>
          </v-spacer>
          <v-flex xs3>
            <v-text-field label="Search" v-model="search">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="millingCharges"
          :items-per-page="5"
          :search="search"
          class="elevation-1"
        >
		<template v-slot:item.documentUpload.fileName="{ item }">
                <a
                  href="#"
                  class="primary--text"
                  @click.prevent="downloadContractPDF(item)"
                >
                  {{ item.documentUpload.fileName }}
                </a>
              </template>
          <template v-slot:item.documentUpload.dateCreated="{ item }">
            {{ formatDate(item.documentUpload.dateCreated) }}
          </template>
          <template v-slot:item.partyBApprovalTime="{ item }">
            {{ formatTimestamp(item.partyBApprovalTime) }}
          </template>
          <template v-slot:item.nceApprovalTime="{ item }">
            {{ formatTimestamp(item.nceApprovalTime) }}
          </template>
          <template v-slot:item.coopApprovalTime="{ item }">
            {{ formatTimestamp(item.coopApprovalTime) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>

  </v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import http from '../../../http'
import { mapState } from 'vuex'

export default {
	name: 'catalogueupload',
	data: function () {
		return {
			gradeDisabled: true,
			millingCharges: [],
			editFarmerType: {},
			editCoffeeType: {},
			editGrade: {},
			editStatus: '',
			cherryRateTemp: { rate: 0, name: 'hello' },
			headers: [
				{ text: 'Upload Org', value: 'documentUpload.organisation.organisationName' },
				{ text: 'Upload Date', value: 'documentUpload.dateCreated' },
				{ text: 'Upload User', value: 'documentUpload.createdBy' },
				{ text: 'Counter Party Name', value: 'partyBorg.organisationName' },
				{ text: 'Approving User', value: 'partyB.username' },
				{ text: 'Approval Date', value: 'partyBApprovalTime' },
				{ text: 'NCE Approver', value: 'nceApprover.username' },
				{ text: 'NCE Approval Date', value: 'nceApprovalTime' },
				{ text: 'BANK Approver', value: 'coopApprover.username' },
				{ text: 'BANK Approval Date', value: 'coopApprovalTime' },
				{ text: 'Grower', value: 'grower.organisationName' },
				{ text: 'GrowerCode', value: 'grower.organisationCode' },
				{ text: 'Miller', value: 'miller.organisationName' },
				{ text: 'Milling Charge', value: 'millingCharge' },
				{ text: 'Parchment Transport Charge', value: 'parchmentTransportCharge' },
				{ text: 'Clean Handsorting Charge', value: 'cleanHandSortingCharge' },
				{ text: 'Parchment Drying Charge', value: 'parchmentDryingCharge' },
				{ text: 'Clean Storage Charge', value: 'cleanStorageCharge' },
				{ text: 'Clean Transport Charge', value: 'cleanTransportCharge' },
				{ text: 'Parchment Handling Charge', value: 'parchmentHandlingCharge' },
				{ text: 'Clean Handling Charge', value: 'cleanHandlingCharge' },
				{ text: 'Colorsorting Charge', value: 'colorSortingCharge' },
				{ text: 'Export Bag Charge', value: 'exportBagCharge' },
				{ text: 'Contract', value: 'documentUpload.fileName' },
				{ text: 'Status', value: 'status.statusName' }

			],
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			pagination: { sortBy: 'id', descending: true },
			search: '',
			permissions: [],
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			confirmDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			rateLimitDialog: false,
			editRateLimitDialog: false,
			approveRateLimitDialog: false,
			userID: 0,
			organisationType: null
		}
	},
	mounted () {
		this.getMillingCharges()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		files () {
			this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		...mapState({ user: state => state.user }),
		canUploadFarmers: function () {
			return this.hasPerm('CAN_UPLOAD_FARMERS')
		},
		canCreateRate: function () {
			return this.hasPerm('CAN_CREATE_CCARF_RATE')
		},
		canUpdateRate: function () {
			return this.hasPerm('CAN_UPDATE_CCARF_RATE')
		},
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		},
		userId: function () {
			if (this.user) {
				console.log('user - ', this.user)
				this.organisationType = this.user.organisation.organisationType.name
				this.userID = this.user.id
				return this.user.id
			}
			return 0
		}
	},
	methods: {
		formatTimestamp (timestamp) {
			if (timestamp === null || timestamp === undefined || timestamp === '') {
				return ''
			}
			const date = new Date(timestamp)
			const year = date.getFullYear()
			const month = ('0' + (date.getMonth() + 1)).slice(-2) // Add 1 because months are 0-indexed
			const day = ('0' + date.getDate()).slice(-2)
			const hours = ('0' + date.getHours()).slice(-2)
			const minutes = ('0' + date.getMinutes()).slice(-2)
			return `${month}/${day}/${year} ${hours}:${minutes}`
		},
		formatDate (timestamp) {
			if (timestamp === null || timestamp === undefined || timestamp === '') {
				return ''
			}
			const date = new Date(timestamp)
			const year = date.getFullYear()
			const month = ('0' + (date.getMonth() + 1)).slice(-2) // Add 1 because months are 0-indexed
			const day = ('0' + date.getDate()).slice(-2)
			return `${month}/${day}/${year}`
		},
		downloadContractPDF (file) {
			console.log("filessss00 -> ", file)
			//let base64String = null;
			if (this.organisationType === 'MILLER'){
				console.log("filessss11 -> ", file)
				this.findDocument(file['documentUpload']['fileId']);
				//base64String = newFile.file;
				return;
			} 
			console.log("filessss -> ", file)
			// Base64 encoded string of a small PDF file
			const base64String = file.documentUpload.file

			// This function converts a base64 string to a Blob
			function base64ToBlob (base64, type) {
				const binary = atob(base64.replace(/\s/g, ''))
				const len = binary.length
				const buffer = new ArrayBuffer(len)
				const view = new Uint8Array(buffer)
				for (let i = 0; i < len; i++) {
					view[i] = binary.charCodeAt(i)
				}
				return new Blob([view], { type: type })
			}

			const blob = base64ToBlob(base64String, 'application/pdf')
			const url = window.URL.createObjectURL(blob)

			const downloadLink = document.createElement('a')
			downloadLink.href = url
			downloadLink.setAttribute(
				'download',
				file.documentUpload.fileName + '.pdf'
			)
			document.body.appendChild(downloadLink)
			downloadLink.click()

			// Clean up
			window.URL.revokeObjectURL(url)
			document.body.removeChild(downloadLink)
		},
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		openCreateDialog () {
			this.rateLimitDialog = true
		},
		getMillingCharges () {
			http.get(config.serverURI + '/miller/findAll')
				.then(response => {
					this.millingCharges.length=0
					response.data.forEach(x => {
						if (x.status.statusName === 'APPROVED') {
							this.millingCharges.push(x)
						}
					})
					// this.millingCharges = response.data
					this.millingCharges.forEach(x => {
						if (x.status.statusName === 'PENDING_CHECKER_APPROVAL') {
							const creatingOrg = x.creatingOrganisation.organisationName
							console.log('creatingOrg ', creatingOrg)
							const org = x.miller.organisationName
							console.log('org ', creatingOrg)
							const grower = x.grower.organisationName
							console.log('grower ', creatingOrg)
							let name = 'PENDING ' + org + ' APPROVAL'
							if (creatingOrg === org) {
								name = 'PENDING ' + grower + ' APPROVAL'
							}
							x.status.statusName = name
						}
					})
					console.log('RR -> ', response.data)
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		findDocument (id) {
			http.get(config.serverURI + '/miller/findDocumentById?id='+id)
				.then(response => {
					console.log('findDocument -> ', response.data)
					const fileName = response.data.fileName
					const base64String = response.data.file
					console.log('file -> ', base64String)
					console.log('fileNme -> ', fileName)
					function base64ToBlob (base64, type) {
						const binary = atob(base64.replace(/\s/g, ''))
						const len = binary.length
						const buffer = new ArrayBuffer(len)
						const view = new Uint8Array(buffer)
						for (let i = 0; i < len; i++) {
							view[i] = binary.charCodeAt(i)
						}
						return new Blob([view], { type: type })
					}

					const blob = base64ToBlob(base64String, 'application/pdf')
					const url = window.URL.createObjectURL(blob)

					const downloadLink = document.createElement('a')
					downloadLink.href = url
					downloadLink.setAttribute(
						'download',fileName + '.pdf'
					)
					document.body.appendChild(downloadLink)
					downloadLink.click()

					// Clean up
					window.URL.revokeObjectURL(url)
					document.body.removeChild(downloadLink)
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		}
	}
}

</script>
<style>
.main-layout {
  margin-top: 15px;
}
.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn{
  padding: 10px;
  margin: 5px;
}
.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col{
  border: 1px solid brown;
}
</style>
